import GatewayBase from './gateway-base';
import { FilterType } from '@constants';

export default class FiltersRestService extends GatewayBase {
  get filters() {
    return {
      ofType: this.getFilters,
    };
  }

  private getFilters = (type: FilterType) => {
    switch (type) {
      // STORE CREDIT
      case FilterType.storeCredit: {
        return this.client.get<any>(`/v1/claims/filters/ClaimStoreCredit`);
      }
      // CLAIM
      case FilterType.claim: {
        return this.client.get<any>(`/v1/claims/filters/Claim`);
      }
      // ORDER
      case FilterType.order: {
        return this.client.get<any>(`/v1/orders/filters/Order`);
      }
      default:
        throw new Error(`Unsupported filter type: ${type}`);
    }
  };
}
